import { Country } from 'helpers/conf';

export const ANJOUAN_COUNTRIES: string[] = [
  Country.India,
  Country.Zimbabwe,
  Country.Canada,
];
